import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

import { AddRosterPageRoutingModule } from './add-roster-routing.module';

import { AddRosterPage } from './add-roster.page';
import { BhInputComponentModule } from 'src/app/components/_core/bh-input/bh-input.component.module';
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ReactiveFormsModule,
    AddRosterPageRoutingModule,
    BhInputComponentModule
  ],
  declarations: [AddRosterPage]
})
export class AddRosterPageModule {}
